<template>
  <div class="cat-container" :id="cat ? cat.key : ''">
    <div v-if="catDescr || catDetail" class="cat-header">
      <div v-if="catDescr" class="-descr">{{ catDescr }}</div>
      <div v-if="catDetail" class="-detail">
        {{ catDetail }}
      </div>
    </div>

    <div class="items-container">
      <v-row>
        <v-col
          :class="[                                                                                                                                                                                 
            'menu-col',
            {
              'pl-1': $vuetify.breakpoint.xsOnly,
            },
          ]"
          cols="3"
          v-for="(item, index) in items"
          :key="item.ID"
        >
          <MenuItemEle
            :item="item"
            :itemIndex="index"
            @itemClicked="itemClicked"
            @refreshing="
              (flag) => {
                refreshing = flag;
              }
            "
          ></MenuItemEle>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import MenuItemEle from "@/components/MenuItemEle.vue";

export default {
  props: {
    cat: null,
    showCatName: null,
  },

  components: {
    MenuItemEle,
  },

  computed: {
    items() {
      if (this.cat) {
        return this.cat.items.filter(
          (item) => item.orderTypes.includes(this.$store.state.Order.order.orderType) && !item.bItem
        );
      } else return [];
    },

    catDescr() {
      if (!this.cat) return undefined;
      if (!this.showCatName) return undefined;

      let descr = this.cat.descr;
      if (this.$store.state.descrIndex == 1 && this.cat.descr1) descr = this.cat.descr1;
      else if (this.$store.state.descrIndex == 2 && this.cat.descr2) descr = this.cat.descr2;
      return descr;
    },

    catDetail() {
      if (!this.cat) return undefined;

      let detail = this.cat.detail;
      if (this.$store.state.descrIndex == 1 && this.cat.detail1) detail = this.cat.detail1;
      else if (this.$store.state.descrIndex == 2 && this.cat.detail2) detail = this.cat.detail2;
      return detail;
    },
  },

  methods: {
    itemClicked(payload) {
      this.$emit("itemClicked", payload);
    },
  },
};
</script>

<style lang="scss" scoped>
.cat-container {
  position: absolute;
  top: 0px;
  width: 100%;
  height: calc(100vh - 90px - 90px);
  //background-color: rgba(0, 0, 0, 0.6);
  overflow: auto;
  padding: 24px 24px;
  //padding-top: 24px;

  .cat-header {
    background-color: rgba(255, 255, 255, 0.9);
    //margin: 12px 0px !important;
    margin: 0px -4px !important;
    padding: 8px;
    font-size: 0.9em;

    .-descr {
      font-size: 1.2em;
      font-weight: bold;
    }

    .-detail {
    }
  }

  .items-container {
    //margin: 0px 4px !important;
  }
}
</style>
